<template>
  <main class="main">
    <div class="buttons">
      <router-link :to="{ name: 'client-creation' }" custom v-slot="{ navigate }">
        <ButtonElement color="bordeaux" :icon="PhPlus" @click="navigate">
          Ajouter un client
        </ButtonElement>
      </router-link>
    </div>
    <div class="cards" v-if="clients.length">
      <CardComponent
        v-for="client in clients"
        :key="client.id"
        :transparent="!client.actif"
        :icon="PhFolderSimpleUser"
        :title="`${client.raison_sociale}${!client.actif ? ' (supprimé)' : ''}`"
      >
        <template #buttons>
          <router-link
            :to="{ name: 'client-modification', params: { id: client.id } }"
            custom
            v-slot="{ navigate }"
          >
            <ButtonElement
              v-if="client.actif"
              color="bordeaux"
              :icon="PhPen"
              size="small"
              @click="navigate"
              >Modifier</ButtonElement
            >
          </router-link>
          <ButtonElement
            color="danger"
            bordered
            :icon="client.actif ? PhTrash : PhRecycle"
            :disabled="!cacheStore.online"
            size="small"
            label-class="tablet-only"
            @click="confirmDeleteClient(client)"
            >{{ client.actif ? 'Supprimer' : 'Restaurer' }}</ButtonElement
          >
        </template>
      </CardComponent>
    </div>
    <div class="message" v-else>
      <PhWarning />
      <span>Aucun client n'est enregistré.</span>
    </div>
  </main>
  <ConfirmElement ref="confirmRef" @yes="deleteClient" />
</template>

<script setup lang="ts">
import {
  PhFolderSimpleUser,
  PhPen,
  PhPlus,
  PhRecycle,
  PhTrash,
  PhWarning,
} from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import useFetch from '@/composables/useFetch.ts'
import { onMounted, ref, type Ref, useTemplateRef } from 'vue'
import { useLoadingStore } from '@/stores/loading.ts'
import ConfirmElement from '@/components/ConfirmElement.vue'
import CardComponent from '@/components/card/CardComponent.vue'
import type ClientList from '@/interfaces/Client.ts'
import { useCacheStore } from '@/stores/cache.ts'

// dépendances
const api = useFetch()

// stores
const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()

const clients: Ref<ClientList[]> = ref([])

const confirmRef = useTemplateRef<typeof ConfirmElement>('confirmRef')

async function getClients() {
  clients.value = await cacheStore.getClients()
}

function confirmDeleteClient(client: ClientList) {
  confirmRef.value?.show(
    client,
    `${client.actif ? 'Suppression' : 'Restauration'} d\'un client`,
    `Êtes-vous sûr de vouloir ${client.actif ? 'supprimer' : 'restaurer'} le client <b class="b">${client.raison_sociale}</b> ?`,
  )
}

async function deleteClient(client: ClientList) {
  loadingStore.start()
  try {
    await api.delete(`clients/${client.id}`)
    await getClients()
  } finally {
    loadingStore.stop()
  }
}

onMounted(async () => {
  await getClients()
})
</script>
